import { useTranslation } from "react-i18next";

import { getGreetingKey } from "../utils/greeting";

export function useGreeting(firstName?: string | null): string {
  const { t } = useTranslation();
  const key = getGreetingKey();
  const name = firstName?.trim();
  return name
    ? t(`home.greeting.${key}WithName`, { name })
    : t(`home.greeting.${key}`);
}
